const NotificationType = {
  INFO: 'INFO',
  ERROR: 'ERROR',
  WARNING: 'WARNING',
  SUCCESS: 'SUCCESS',
} as const;

export { NotificationType };
